import { DeleteCompanyUserMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const deleteCompanyUserHandler =
  graphql.mutation<DeleteCompanyUserMutation>(
    "deleteCompanyUser",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          deleteCompanyUser: {
            result: true,
          },
        },
      });
    }
  );
